var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { analyticsEventEmitter } from '../emitter';
export var EVENT_STAT_NAME = 'Supplier_Basic_Request_Cache_Stat';
export var EVENT_PRUNE_NAME = 'Supplier_Basic_Request_Cache_Prune';
export var sendApiCacheEventHit = function (_a) {
    var projectName = _a.projectName;
    return function (_a) {
        var cacheKey = _a.cacheKey, expires = _a.expires, size = _a.size, cacheState = _a.cacheState;
        analyticsEventEmitter.sendEvent({
            name: EVENT_STAT_NAME,
            params: __assign(__assign({}, cacheState), { cacheKey: cacheKey,
                expires: expires,
                size: size, hit: "" + true, projectName: projectName }),
            customEvent: true,
        });
    };
};
export var sendApiCacheEventMiss = function (_a) {
    var projectName = _a.projectName;
    return function (_a) {
        var cacheKey = _a.cacheKey, cacheState = _a.cacheState;
        analyticsEventEmitter.sendEvent({
            name: EVENT_STAT_NAME,
            params: __assign(__assign({}, cacheState), { cacheKey: cacheKey, hit: "" + false, projectName: projectName }),
            customEvent: true,
        });
    };
};
export var sendApiCachePruneEvent = function (pruneCacheParams) {
    analyticsEventEmitter.sendEvent({
        name: EVENT_PRUNE_NAME,
        params: pruneCacheParams,
        customEvent: true,
    });
};
